import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  addObj,
  modifyObj,
  deleteObj,
} from '@/api/vehiclemodelserv'

export default {
  state: {
    state_VehicleModel_GetAllResult: null,
    state_VehicleModel_SearchByNameResult: null,
    state_VehicleModel_GetPageResult: null,
    state_VehicleModel_GetDetailResult: null,
    state_VehicleModel_AddObjResult: null,
    state_VehicleModel_ModifyObjResult: null,
    state_VehicleModel_DeleteObjResult: null,
  },
  mutations: {
    SET_VEHICLEMODEL_GETALL_RESULT: (state, rst) => {
      state.state_VehicleModel_GetAllResult = rst;
    },
    SET_VEHICLEMODEL_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_VehicleModel_SearchByNameResult = rst;
    },
    SET_VEHICLEMODEL_GETPAGE_RESULT: (state, rst) => {
      state.state_VehicleModel_GetPageResult = rst;
    },
    SET_VEHICLEMODEL_GETDETAIL_RESULT: (state, rst) => {
      state.state_VehicleModel_GetDetailResult = rst;
    },
    SET_VEHICLEMODEL_ADDOBJ_RESULT: (state, rst) => {
      state.state_VehicleModel_AddObjResult = rst;
    },
    SET_VEHICLEMODEL_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_VehicleModel_ModifyObjResult = rst;
    },
    SET_VEHICLEMODEL_DELETEOBJ_RESULT: (state, rst) => {
      state.state_VehicleModel_DeleteObjResult = rst;
    },
  },
  actions: {
    VehicleModelServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEMODEL_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEMODEL_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleModelServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEMODEL_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEMODEL_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleModelServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEMODEL_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEMODEL_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleModelServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEMODEL_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEMODEL_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleModelServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEMODEL_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEMODEL_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleModelServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEMODEL_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEMODEL_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleModelServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEMODEL_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEMODEL_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_VehicleModel_GetAllResult: state => {
      return state.state_VehicleModel_GetAllResult;
    },
    get_VehicleModel_SearchByNameResult: state => {
      return state.state_VehicleModel_SearchByNameResult;
    },
    get_VehicleModel_GetPageResult: state => {
      return state.state_VehicleModel_GetPageResult;
    },
    get_VehicleModel_GetDetailResult: state => {
      return state.state_VehicleModel_GetDetailResult;
    },
    get_VehicleModel_AddObjResult: state => {
      return state.state_VehicleModel_AddObjResult;
    },
    get_VehicleModel_ModifyObjResult: state => {
      return state.state_VehicleModel_ModifyObjResult;
    },
    get_VehicleModel_DeleteObjResult: state => {
      return state.state_VehicleModel_DeleteObjResult;
    },
  }
}